(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('rls-site-header')) {
    class RLSiteHeader extends HTMLElement {
      connectedCallback() {
        this.menuButton = this.querySelector('.rls-menu-button');
        this.menuLabel = this.querySelector('.rls-menu-button__label');
        this.mobileNavigation = this.querySelector('.rls-mobile-nav');
        this.mobileLinks = [...this.querySelectorAll('.rls-mobile-nav a')];
        this.mobileHeaderUtilityLinks = [
          ...this.querySelectorAll('.rls-header__utilities .header__icon'),
        ];
        this.previouslyFocusedElement = null;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.menuButton?.addEventListener('click', this.handleMenuClick);
        this.mobileLinks.forEach((link) => link.addEventListener('click', this.closeMenu));
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        document.addEventListener('keydown', this.handleKeydown);

        this.handleScroll();
      }

      disconnectedCallback() {
        this.menuButton?.removeEventListener('click', this.handleMenuClick);
        this.mobileLinks?.forEach((link) => link.removeEventListener('click', this.closeMenu));
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.classList.remove('rls-menu-open');
      }

      handleScroll() {
        if (this.classList.contains('menu-is-open')) return;
        this.classList.toggle('is-scrolled', window.scrollY > 28);
      }

      handleMenuClick() {
        const shouldOpen = !this.classList.contains('menu-is-open');

        if (shouldOpen) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      }

      openMenu() {
        this.previouslyFocusedElement = document.activeElement;
        this.classList.remove('is-scrolled');
        this.classList.add('menu-is-open');
        document.body.classList.add('rls-menu-open');
        this.menuButton?.setAttribute('aria-expanded', 'true');
        this.mobileNavigation?.setAttribute('aria-hidden', 'false');

        if (this.menuLabel) {
          this.menuLabel.textContent = this.menuLabel.dataset.closeLabel || 'Close';
        }

      }

      closeMenu() {
        if (!this.classList.contains('menu-is-open')) return;

        this.classList.remove('menu-is-open');
        document.body.classList.remove('rls-menu-open');
        this.menuButton?.setAttribute('aria-expanded', 'false');
        this.mobileNavigation?.setAttribute('aria-hidden', 'true');

        if (this.menuLabel) {
          this.menuLabel.textContent = this.menuLabel.dataset.openLabel || 'Menu';
        }

        this.handleScroll();

        if (this.previouslyFocusedElement instanceof HTMLElement) {
          this.previouslyFocusedElement.focus({ preventScroll: true });
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.closeMenu();
          return;
        }

        if (event.key !== 'Tab' || !this.classList.contains('menu-is-open')) return;

        const focusableElements = [
          ...this.mobileHeaderUtilityLinks,
          this.menuButton,
          ...this.mobileLinks,
        ].filter((element) => element && element.offsetParent !== null);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }

      handleResize() {
        if (window.innerWidth >= 920) {
          this.closeMenu();
        }
      }
    }

    customElements.define('rls-site-header', RLSiteHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
